import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { clearSelectedVisitTaskAction, updateVisitTaskAction } from '../../../../redux/actions/visitTasksActions';
import { createTask } from '../../../../redux/api/tasksApi';
import { convertToVisitTaskRequest } from '../../../../utils/requestMapper';
import Button from '../../../shared/buttons/Button';
import Modal from '../../../shared/modal/Modal';
import VisitTaskForm from '../forms/VisitTaskForm';

const UpdateVisitTaskModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { vin, id } = useSelector((state) => state.visit.visit);
  const visitTask = useSelector((state) => state.visitTasks?.visitTask);

  const onSubmit = async (data) => {
    setLoading(true);

    if (data.taskName) {
      const { error, data: newTask } = await createTask({ name: data.taskName, hours: data.hours });
      if (error) {
        toast.error(error?.message || 'Не вдалося створити послугу');
        setLoading(false);
        return;
      }
      data.task = { id: newTask.id };
    }

    if (!data.task?.id) {
      toast.error('Оберіть послугу або створіть нову');
      setLoading(false);
      return;
    }

    const task = convertToVisitTaskRequest(data);
    await dispatch(updateVisitTaskAction(vin, id, visitTask.id, task));
    await dispatch(clearSelectedVisitTaskAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити послугу'}
      loading={loading}
      onClose={onModalClose}
      body={<VisitTaskForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} task={visitTask} />}
      actionButton={
        !readOnly && (
          <Button
            type={'submit'}
            disabled={loading}
            variant={'primary'}
            formId={'visitTask-form'}
            children={'Змінити'}
          />
        )
      }
    />
  );
};

export default UpdateVisitTaskModal;
